module.exports = __webpack_public_path__ + "img/auth-patient-banner.0f33530d.jpeg";